const mobileFilters = document.querySelectorAll("[data-blog-mobile-filters]");

mobileFilters.forEach((filters) => {
  const triggers = filters.querySelectorAll("[data-blog-mobile-filter-trigger]");
  const backdrop = filters.querySelector("[data-blog-mobile-filters-backdrop]");
  const panels = filters.querySelectorAll("[data-blog-mobile-filter-panel]");
  const closeButtons = filters.querySelectorAll("[data-blog-mobile-filters-close]");

  const closeFilters = () => {
    backdrop.classList.add("is-hidden");
    document.body.classList.remove("blog-filters-open");

    triggers.forEach((trigger) => trigger.setAttribute("aria-expanded", "false"));
    panels.forEach((panel) => {
      panel.classList.remove("is-active");
      panel.setAttribute("aria-hidden", "true");
    });
  };

  const openFilter = (filterName) => {
    backdrop.classList.remove("is-hidden");
    document.body.classList.add("blog-filters-open");

    triggers.forEach((trigger) => {
      trigger.setAttribute(
        "aria-expanded",
        String(trigger.dataset.blogMobileFilterTrigger === filterName),
      );
    });

    panels.forEach((panel) => {
      const isActive = panel.dataset.blogMobileFilterPanel === filterName;

      panel.classList.toggle("is-active", isActive);
      panel.setAttribute("aria-hidden", String(!isActive));
    });
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      openFilter(trigger.dataset.blogMobileFilterTrigger);
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", closeFilters);
  });

  backdrop.addEventListener("click", (event) => {
    if (event.target === backdrop) {
      closeFilters();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeFilters();
    }
  });
});
